<script setup>
import { ref, computed  } from 'vue'
import { useStore } from 'vuex'
import {
  Button,
  Overlay
} from 'vant'

const emit = defineEmits(['close', 'confirm'])

const store = useStore()

const content = computed(() => {
  return store.getters?.getQuesInfo?.popupContent || ''
})

function handleBtnClick(isAgree) {
  if (isAgree) {
    emit('confirm')
  } else {
    emit('close')
  }
}
</script>
<template>
  <div class="before-wrap">
    <p class="content-wrap" v-html="content"></p>
    <div class="before-footer">
      <Button @click="handleBtnClick(false)" class="footer-btn">不同意</Button>
      <Button @click="handleBtnClick(true)" class="footer-btn confirm-btn">同意</Button>
    </div>
  </div>
  <Teleport to="body">
    <div class="before-mask">
    </div>
  </Teleport>
</template>
<style lang="scss" scoped>
.before-wrap {
  box-sizing: border-box;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  padding: 5px 30px;
  padding-bottom: 120px;
  width: 646px;
  max-height: 757px;
  min-height: 200px;
  border-radius: 14px;
  background-color: #fff;
  z-index: 2077;

  .content-wrap {
    overflow-y: auto;
    height: 100%;

    // 美化滚动条
    &::-webkit-scrollbar {
      display: block;
      width: 15px;
    }

    /* 两个滚动条交接处 -- x轴和y轴 */
    &::-webkit-scrollbar-corner {
      background-color: transparent;
    }

    /* 滚动条滑块 */
    &::-webkit-scrollbar-thumb {
      border-radius: 10px;
      background: #EDEDED;
    }

    /* 滚动条轨道 */
    &::-webkit-scrollbar-track {
      display: none;
    }


  }


  .before-footer {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 100px;
    border-top: 1px solid #EAEAEA;
    background-color: #f5f5f5;
    border-radius: 14px;

    .footer-btn {
      flex: 1;
      height: 100%;
      text-align: center;
      font-size: 34px;
      color: #9D9D9D;
      border: none;
      background-color: transparent;
    }

    .confirm-btn {
      color: #32A4DF;
    }
  }

  :deep {
    * {
      margin: revert;
      padding: revert;
    }

    * {
      font-weight: normal;
      font-size: 14px;
      font-style: normal;
    }

    * {
      font-weight: revert;
      font-size: revert;
      font-style: revert;
    }

    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
      margin: 25px 0;
    }


    p {
      margin: 20px 0;
      line-height: 1.5;
      font-size: 32px;
    }

    strong {
      font-weight: bold;
    }
  }

}

.before-mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 2076;
}
</style>